<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">LMCV - JP Report</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-12 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
<!--          <div class="form-group py-1 mx-3">-->
<!--            <label class="form-control-xs font-weight-bold" for="onboardFrom">-->
<!--              Onboard From:-->
<!--            </label>-->
<!--            <input id="onboardFrom" v-model="params.onboard_from" :disabled="isLoading"-->
<!--                   class="form-control form-control-xs mx-2" type="date">-->
<!--          </div>-->
<!--          <div class="form-group py-1 mx-3">-->
<!--            <label class="form-control-xs font-weight-bold" for="onboardFrom">-->
<!--              Onboard To:-->
<!--            </label>-->
<!--            <input id="onboardTo" v-model="params.onboard_to" :disabled="isLoading"-->
<!--                   class="form-control form-control-xs mx-2" type="date">-->
<!--          </div>-->
          <div class="form-group py-1 mx-3">
            <label class="form-control-xs font-weight-bold" for="vessels">Select Vessel: </label>
            <select id="vessels" v-model="params.vessel_id"
                    :disabled="isLoading" class="form-control form-control-xs mx-2">
              <option id="vesselOption0" :value="null" disabled selected>---Select Vessel ---</option>
              <option value="">ALL VESSEL</option>
              <option v-for="vessel in japaneseVessels" :key="vessel.id" :value="vessel.id">
                {{ vessel.name }}
              </option>
            </select>
          </div>
<!--          <div v-if="isPrincipal" class="form-group py-1 mx-3">-->
<!--            <label class="form-control-xs font-weight-bold" for="manning">Select Manning: </label>-->
<!--            <select id="manning" v-model="params.manning_id" :disabled="isLoading"-->
<!--                    class="form-control form-control-xs mx-2" name="manning">-->
<!--              <option id="manningOption0" :value="null" disabled selected>-&#45;&#45;Select Manning -&#45;&#45;</option>-->
<!--              <option value="">ALL MANNING</option>-->
<!--              <option v-for="manningKey in manningKeys"-->
<!--                      :key="manningKey.id"-->
<!--                      :title="manningKey.name"-->
<!--                      :value="manningKey.id">-->
<!--                {{ manningKey.alias }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
          <div class="form-group py-1 mx-3">
            <label class="form-control-xs font-weight-bold" for="rank">Select Rank: </label>
            <select id="rank" v-model="params.rank_id" :disabled="isLoading"
                    class="form-control form-control-xs mx-2" name="rank">
              <option id="rankOption0" :value="null" disabled selected>---Select Ranks ---</option>
              <option value="">ALL RANKS</option>
              <option v-for="rankKey in rankKeys"
                      :key="rankKey.id"
                      :title="rankKey.name"
                      :value="rankKey.id"
              >{{ rankKey.alias }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-10 text-center d-flex align-items-center mt-3">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li
                :class="{ disabled: pagination.currentPage === 1 }"
                class="page-item"
            >
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li
                v-for="page in paginationPages"
                :key="page"
                :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
                class="page-item"
            >
              <button class="page-link" @click="setPage(page)">
                {{ page }}
              </button>
            </li>

            <li
                :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
                class="page-item"
            >
              <button class="page-link" @click="setPage(pagination.lastPage)">
                Last
              </button>
            </li>
          </ul>
        </nav>
        <small class="mx-3">{{
            `${pagination.from} to ${pagination.to} of ${pagination.total}`
          }}</small>
      </div>
      <div class="col-2 text-center d-flex justify-content-end align-items-center">
        <button v-if="!isLoading" id="generateReport"
                :disabled="params.vessel_id === null && params.manning_id === null && params.rank_id === null"
                class="btn btn-primary btn-xs p-1 d-flex align-items-center">
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate Report
        </button>
      </div>
      <div class="col col-12">
        <div v-if="isLoading">
          <app-loading></app-loading>
        </div>
        <div class="table-responsive my-2" v-else>
          <table id="tblLmcv"
              class="table table-hover table-bordered table-template-1 text-small table-striped">
            <thead>
            <tr class="e-nowrap-all">
              <th class="sticky-scroll-1" rowspan="2" scope="col" style="min-width: 44px !important">Rank</th>
              <th class="sticky-scroll-2" rowspan="2" scope="col" >Name of Crew (First / M. / Last)
              </th>
              <th rowspan="2" scope="col" ><span class="d-block">Travel</span> Docs Holder</th>
              <th rowspan="2" scope="col" ><span class="d-block">Joining</span> Date</th>
              <th rowspan="2" scope="col" ><span class="d-block">Date of Onboard</span> Familiarization</th>
              <template v-for="(cols,index) in lmcvCols">
                <th :key="index" :colspan="cols.sub_cols.length" scope="col" >
                  {{ cols.name }}
                </th>
              </template>
            </tr>
            <tr class="e-nowrap-all">
              <template v-for="(cols,ind) in lmcvCols">
                <template v-for="(sub,index) in cols.sub_cols">
                  <th :class="{'issue_date-bg':['ISSUE DATE','Issue Date'].includes(sub)}"
                      :key="'sub_cols-'+ind+index" scope="col"> {{ sub }}</th>
                </template>
              </template>
            </tr>
            </thead>
            <tbody class="text-small">
            <template v-for="(crew, index) in lmcv">
              <tr :key="index" class="e-nowrap-all">
                <td class="text-center sticky-scroll-1" style="min-width: 44px !important">{{ crew.rank }}</td>
                <td class="text-left sticky-scroll-2">
                  <router-link :to="{name:'CrewActivity',params:{id:crew.crew_id}}" target="_blank"
                               v-if="crew.crewName" class="mb-0">{{ crew.crewName }}
                  </router-link>
                </td>
                <td></td>
                <td class="text-center">{{crew.embarkationDate}}</td>
                <td></td>
                <template v-for="(doc,index) in crew.documents">
                  <template v-if="['SCC','YFEV'].includes(doc.code)">
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">
                      {{ doc.issued_date | moment('DD MMM YYYY') }}
                    </td>
                  </template>

                  <template v-if="['MED'].includes(doc.code)">
                    <td class="text-center"
                        :class="{
                      'bg-danger text-white':doc.warningColor==='RED',
                      'bg-warning text-white':doc.warningColor==='YELLOW',
                      'bg-primary text-white':doc.warningColor==='BLUE',
                    }"
                        :key="'doc_no-'+doc.code+index+crew.crew_id">
                      {{ doc.expiry_date | moment('DD MMM YYYY') }}
                    </td>
                  </template>
                  <template v-if="['HS','GOCSB','3RE','FLSSOC','FLSSO'].includes(doc.code)">
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">{{ doc.doc_no }}</td>
                    <td class="text-center" :key="'expiry_date-'+doc.code+index+crew.crew_id">
                      {{ doc.issued_date | moment('DD MMM YYYY') }}
                    </td>
                  </template>
                  <template v-if="['NSB','NCOC','NCOE','NGMDSS','FL','AMCV','USVISA','PP'].includes(doc.code)">
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">{{ doc.doc_no }}</td>
                    <td class="text-center" :class="{
                        'bg-danger text-white':doc.warningColor==='RED',
                        'bg-warning text-white':doc.warningColor==='YELLOW',
                        'bg-primary text-white':doc.warningColor==='BLUE',
                       }" :key="'expiry_date-'+doc.code+index+crew.crew_id">{{ doc.expiry_date | moment('DD MMM YYYY') }}</td>
                  </template>
                  <template v-else-if="['CEMP','CEX'].includes(doc.code)">
                    <td class="text-center" :key="'issued_date-'+doc.code+index+crew.crew_id">
                      {{ doc.issued_date | moment('DD MMM YYYY') }}
                    </td>
                    <td class="text-center"
                        :class="{
                        'bg-danger text-white':doc.warningColor==='RED',
                        'bg-warning text-white':doc.warningColor==='YELLOW',
                        'bg-primary text-white':doc.warningColor==='BLUE',
                        }"
                        :key="'expiry_date-'+doc.code+index+crew.crew_id">{{ doc.expiry_date | moment('DD MMM YYYY') }}</td>
                  </template>
                  <template v-else-if="doc.length > 1 && ['6251','6342'].includes(doc[0].code || doc[1].code)">
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">
                      {{
                        doc.length  > 1 && doc[0].doc_no ? doc.map(d=>d.doc_no).join('  ') : doc[0].doc_no
                      }}
                    </td>
                    <td class="text-center"
                        :key="'expiry_date-'+doc.code+index+crew.crew_id">
                      {{
                        doc.length  > 1 && doc[0].expiry_date  ?
                        doc.map(d=>d.expiry_date).join(' ') :
                        doc[0].expiry_date | moment('DD MMM YYYY')
                      }}
                    </td>
                  </template>
                  <template v-else-if="doc.length > 1 && ['GOC'].includes(doc[0].code || doc[1].code)">
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">
                      {{
                        doc.length  > 1 && doc[0].doc_no ? doc.map(d=>d.doc_no).join('  ') : doc[0].doc_no
                      }}
                    </td>
                    <td class="text-center"
                        :key="'expiry_date-'+doc.code+index+crew.crew_id">
                      {{
                        doc.length  > 1 && doc[0].issued_date  ?
                            doc.map(d=>d.issued_date).join('  ') :
                            doc[0].issued_date | moment('DD MMM YYYY')
                      }}
                    </td>
                  </template>
                  <template v-else-if="['VACCINE'].includes(doc.code)">
                    <td class="text-center"
                        :key="'completed-date-'+doc.code+index+crew.crew_id">
                      {{
                        doc.completion_date ? doc.completion_date : doc.inoculate_date | moment('DD MMM YYYY')
                      }}
                    </td>
                    <td class="text-center" :key="'brand-'+doc.code+index+crew.crew_id">
                      {{
                        doc.brand
                      }}
                    </td>
                    <td class="text-center" :key="'country-'+doc.code+index+crew.crew_id">
                      {{
                        doc.country
                      }}
                    </td>
                  </template>
                  <template v-else-if="['FLSB'].includes(doc.code)">
                    <td class="text-center" :key="'watchkeeping'+index+crew.crew_id">{{doc.watchkeeping_stamp ? 'YES':'NO'}}</td>
                    <td class="text-center" :key="'doc_no-'+doc.code+index+crew.crew_id">{{doc.doc_no}}</td>
                    <td class="text-center"
                        :class="{
                        'bg-danger text-white':doc.warningColor==='RED',
                        'bg-warning text-white':doc.warningColor==='YELLOW',
                        'bg-primary text-white':doc.warningColor==='BLUE',
                       }" :key="'expiry_date-'+doc.code+index+crew.crew_id">
                      {{doc.expiry_date | moment('DD MMM YYYY')}}
                    </td>
                  </template>
                </template>
              </tr>
              <template v-if="lmcv[index+1]">
                <tr :key="'break'+index" v-if="crew.rank_level !== lmcv[index + 1 ].rank_level">
                  <td colspan="100%" style="height: 20px;"></td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from "vuex";
import appLoading from "@/components/elements/AppLoading";

export default {
  name: "GenerateLMCVReport",
  mixins: [vueAppMixin, gateMixin],
  components:{appLoading},
  data() {
    return {
      params: {
        onboard_from: null,
        onboard_to: null,
        vessel_id: null,
        manning_id: null,
        rank_id: null
      },
    }
  },
  computed: {
    ...mapGetters([
      'vesselKeys',
      'manningKeys',
      'rankKeys',
      'pagination',
      'lmcvCols',
       'lmcv'
    ]),
    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
    japaneseVessels(){
      return this.vesselKeys.filter(vessel=>{
        return vessel.flag !=null ? vessel.flag.flag_id===2 : false;
      });
    }
  },
  async created() {
    await this.getLmcvCols();
    await this.getRankKeys();
    // await this.getManningKeys();
    await this.getVesselKeys();
  },
  methods: {
    ...mapActions([
      'getLmcvCols',
      'generateLmcv',
      // 'getManningKeys',
      'getRankKeys',
      'getVesselKeys'
    ]),
    async setPage(e=null){
      this.params.page=e ?? 1
      await this.generateLmcv(this.params);
    }
  },
  watch:{
    'params.onboard_from'() {
      this.generateLmcv(this.params);
      this.pagination.currentPage = 0;
    },
    'params.onboard_to'() {
      this.generateLmcv(this.params);
      this.pagination.currentPage = 0;
    },
    'params.vessel_id'() {
      this.setPage(1);
      document.getElementById('vesselOption0').style.display = 'none'
    },
    // 'params.manning_id'() {
    //   this.generateLmcv(this.params);
    //   this.pagination.currentPage = 0;
    //   document.getElementById('manningOption0').style.display = 'none'
    // },
    'params.rank_id'() {
      this.setPage(1);
      document.getElementById('rankOption0').style.display = 'none'
    },
  }
}
</script>

<style scoped>

.issue_date-bg{
 background: #f7cea0 !important;
}
.e-nowrap-all * {
  white-space: nowrap;
}
#tblLmcv thead tr th{
  background: #d6fefe;
}
#tblLmcv tbody tr td{
  font-size: 12px;
}
#tblLmcv tbody tr .sticky-scroll-1,
#tblLmcv thead tr .sticky-scroll-1{
  position: sticky;
  left: 0;
  z-index: 2;
  width: inherit;
  padding: 0 20px;
}
#tblLmcv tbody tr:nth-child(odd) .sticky-scroll-1,
#tblLmcv tbody tr:nth-child(odd) .sticky-scroll-2{
  background: #e3e0e0;
}
#tblLmcv tbody tr:nth-child(even) .sticky-scroll-1,
#tblLmcv tbody tr:nth-child(even) .sticky-scroll-2{
  background: #f1f1f1;
}

#tblLmcv tbody > tr .sticky-scroll-2,
#tblLmcv thead tr .sticky-scroll-2{
  position: sticky;
  left: 44px;
  z-index: 2;
  width: inherit;
  padding: 0 20px;
}
</style>
